export const reinitializePaymentStatus = {
  INITIAL: "initial",
  NOT_CONFIRMED: "notConfirmed",
  REINITIALIZE: "reinitialize",
  CONFIRMED: "confirmed",
};
